(function($) {
    'use strict';

    var templatename = {

        init: function() {
            // call below defined function on init
            this.functionName();
        },

        functionName : function () {
            // custom js goes here
        },
    };

    templatename.init();

})(jQuery);

//active menu-bar
$( '.navbar .navbar-nav a' ).on( 'click', function () {
    $( '.navbar .navbar-nav' ).find( 'li.active' ).removeClass( 'active' );
    $( this ).parent( 'li' ).addClass( 'active' );
});


//Header
$(window).scroll(function() {
    if ($(this).scrollTop() > 50){
        $('header').addClass("sticky");
    }
    else{
        $('header').removeClass("sticky");
    }
});


//hamburger Menu
jQuery(document).ready(function (jQuery) {

    jQuery('.navbar').on('click', '.navbar-toggle-btn', function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
            jQuery('#navbar').removeClass('active');
            jQuery('body').removeClass('menu-active');
            jQuery(this).addClass('nav-open').removeClass('nav-close');
        } else {
            jQuery('#navbar').addClass('active');
            jQuery('body').addClass('menu-active');
            jQuery(this).removeClass('nav-open').addClass('nav-close');
        }
    });
});







